import React from 'react';
import { useTranslation } from 'react-i18next';

const TopTeams = ({ tableName, teamList }) => {
    const { t } = useTranslation();

    return (
        <div className="rounded-xl border light-border bg-white p-4 space-y-4">
            <div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
                <h3 className="xl:text-lg text-base font-extrabold uppercase">{t(tableName)}</h3>
                <button className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</button>
            </div>
            <div className="panel-body w-full">
                <table className="table w-full">
                    <thead className="border-b light-border">
                        <tr>
                            <th>{t('teams')}</th>
                            <th className="text-right">{t('points')}</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {teamList && teamList.slice(0, 5)?.map((team, index) => {
                            const trend = team.points > 5 ? "up" : "down";
                            return (
                                <tr key={index}>
                                    <td>
                                        <div className="flex items-center gap-2">
                                            <span className="flex-none size-10 flex justify-center items-center p-1.5 rounded-full border light-border bg-white">
                                                <img src={team?.logo} alt={team?.name} className="w-full" />
                                            </span>
                                            <div className="text-nowrap uppercase">{team?.name}</div>
                                        </div>
                                    </td>
                                    <td className="text-nowrap text-right">
                                        <div className="point-result flex flex-col items-end gap-1">
                                            <span className={trend}>{team?.points}</span>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default TopTeams